module.exports = __webpack_public_path__ + "static/Rosewater3-6f18d38fb5a51a5c880ce0638a4320d2.png";